namespace Matrix.Data {
    export namespace ClientTableService {
        export const baseUrl = 'Data/ClientTable';

        export declare function Create(request: Serenity.SaveRequest<ClientTableRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ClientTableRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ClientTableRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ClientTableRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Parse(request: ClientTableParseRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Data/ClientTable/Create",
            Update = "Data/ClientTable/Update",
            Delete = "Data/ClientTable/Delete",
            Retrieve = "Data/ClientTable/Retrieve",
            List = "Data/ClientTable/List",
            Parse = "Data/ClientTable/Parse"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'Parse'
        ].forEach(x => {
            (<any>ClientTableService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
